import { CourseWithChapters } from "@jelly/lesson";
import { formatLessonsForChapter } from "../../../services/Utils";
import lesson01 from "../../lesson/course-02/lesson-01/lesson";
import lesson02 from "../../lesson/course-02/lesson-02/lesson";
import lesson03 from "../../lesson/course-02/lesson-03/lesson";
import lesson04 from "../../lesson/course-02/lesson-04/lesson";
import lesson05 from "../../lesson/course-02/lesson-05/lesson";
import lesson06 from "../../lesson/course-02/lesson-06/lesson";
import lesson07 from "../../lesson/course-02/lesson-07/lesson";
import lesson08 from "../../lesson/course-02/lesson-08/lesson";
import lesson09 from "../../lesson/course-02/lesson-09/lesson";
import lesson10 from "../../lesson/course-02/lesson-10/lesson";
import lesson11 from "../../lesson/course-02/lesson-11/lesson";
import lesson12 from "../../lesson/course-02/lesson-12/lesson";
import lesson13 from "../../lesson/course-02/lesson-13/lesson";
import lesson14 from "../../lesson/course-02/lesson-14/lesson";
import lesson15 from "../../lesson/course-02/lesson-15/lesson";
import lesson16 from "../../lesson/course-02/lesson-16/lesson";
import lesson17 from "../../lesson/course-02/lesson-17/lesson";
import lesson18 from "../../lesson/course-02/lesson-18/lesson";
import lesson19 from "../../lesson/course-02/lesson-19/lesson";
import lesson20 from "../../lesson/course-02/lesson-20/lesson";
import lesson21 from "../../lesson/course-02/lesson-21/lesson";
import lesson22 from "../../lesson/course-02/lesson-22/lesson";
import lesson23 from "../../lesson/course-02/lesson-23/lesson";
import lesson24 from "../../lesson/course-02/lesson-24/lesson";
import lesson25 from "../../lesson/course-02/lesson-25/lesson";
import lesson26 from "../../lesson/course-02/lesson-26/lesson";
import lesson27 from "../../lesson/course-02/lesson-27/lesson";
import lesson28 from "../../lesson/course-02/lesson-28/lesson";
import lesson29 from "../../lesson/course-02/lesson-29/lesson";
import lesson30 from "../../lesson/course-02/lesson-30/lesson";
import case01 from "../../lesson/course-02/case-01/case";
import case02 from "../../lesson/course-02/case-02/case";
import authorLa from "./authors/author-la";
import authorAh from "./authors/author-ah";
import authorAke from "./authors/author-ake";
import authorAr from "./authors/author-ar";
import authorMr from "./authors/author-mr";
import authorAh2 from "./authors/author-ah2";
import authorYs from "./authors/author-ys";
import authorJa from "./authors/author-ja";

/* eslint-disable max-len */
const data: CourseWithChapters = {
  id: "4eb31243-b6cb-423f-919d-15bba103f7ce",
  publicId: "2",
  slug: "psychoacoustics",
  name: "Psychoacoustics",
  description:
    "Psychoacoustics is the scientific field studying the quantitative relation between acoustic stimuli and the sensation elicited in humans. It is relevant for applications involving human sound perception, such as music encoding and transmission, product sound evaluation or noise control. This course begins with an overview of the anatomy of the human ear and the mechanisms of sound processing and perception. The most relevant psychoacoustic parameters are then introduced before spatial hearing and the basics of binaural recording and reproduction are presented. With the basics covered, some interesting insights into speech, noise and space perception are given. The course also covers important aspects regarding the design and implementation of listening experiments, which are the main tool in psychoacoustic evaluation. Additionally, the course concludes with two case studies for practical application.",
  shortDescription:
    "This is an online course of 30 interactive lessons on psychoacoustics with two case studies for practical application.",
  chapters: [
    {
      id: "26fcd655-ef3e-454e-bba1-cfbafe41cbaa",
      name: "Human perception of sound",
      position: 0,
      chapterLessons: formatLessonsForChapter([lesson01, lesson02, lesson03, lesson04, lesson05]),
    },
    {
      id: "9ab28657-3042-4d27-a1b9-3dc8f1064e44",
      name: "Psychoacoustic Parameters",
      position: 1,
      chapterLessons: formatLessonsForChapter([lesson06, lesson07, lesson08, lesson09, lesson10], 4),
    },
    {
      id: "c26fd525-f26b-478f-8269-0c8c55132a3c",
      name: "Binaural Hearing and Measurements",
      position: 2,
      chapterLessons: formatLessonsForChapter([lesson11, lesson12, lesson13, lesson14, lesson15, lesson16], 9),
    },
    {
      id: "2adc9638-0a24-44d9-bc8a-ba7d6a1ffcef",
      name: "Speech intelligibility",
      position: 3,
      chapterLessons: formatLessonsForChapter([lesson17, lesson18, lesson19, lesson20, lesson21], 15),
    },
    {
      id: "408f309f-b7a5-4ce3-b276-dcd95519f6aa",
      name: "Psychoacoustic listening tests procedures",
      position: 4,
      chapterLessons: formatLessonsForChapter([lesson22, lesson23, lesson24, lesson25, lesson26], 20),
    },
    {
      id: "3797a33d-cce5-423b-936d-1efc04acef1c",
      name: "Further perceptual matters",
      position: 5,
      chapterLessons: formatLessonsForChapter([lesson27, lesson28, lesson29, lesson30], 25),
    },
    {
      id: "4982ef51-7402-47b7-9a64-c06ef517189b",
      name: "Case studies",
      position: 6,
      chapterLessons: formatLessonsForChapter([case01, case02], 30),
    },
  ],
  authors: [authorAh, authorAke, authorAr, authorMr, authorLa, authorAh2, authorYs, authorJa],
};

/* eslint-enable max-len */

export default data;
